<div class="currency-dialog-container">
  
  <!-- Capçalera amb tancament i botó d'inversió de moneda -->
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon>cached</mat-icon>
      <span>{{ 'currencyDialog.title' | translate }}</span>
    </div>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Barra superior de conversió (Estil Google / imatge d'exemple) -->
  <div class="conversion-bar">
    <!-- Esquerra: O EUR o la moneda seleccionada -->
    <div class="conv-side" *ngIf="!inverted">
      <img [src]="eurFlagUrl" alt="EUR">
      <span>1 EUR</span>
    </div>
    <div class="conv-side clickable" *ngIf="inverted" (click)="inverted = false">
      <img [src]="flagUrl(selected.flag)" [alt]="selected.code">
      <span>1 {{ selected.code }}</span>
    </div>

    <!-- Botó d'intercanvi central -->
    <button mat-icon-button class="swap-btn" (click)="toggleDirection()" title="{{ 'currencyDialog.invertirSel' | translate }}">
      <mat-icon>swap_horiz</mat-icon>
    </button>

    <!-- Dreta: Text indicatiu o moneda base -->
    <div class="conv-side">
      <span *ngIf="!inverted">{{ 'currencyDialog.toOthers' | translate }}</span>
      <span *ngIf="inverted">{{ 'currencyDialog.toOthers' | translate }}</span>
    </div>
  </div>

  <!-- Estat de càrrega o error -->
  <div *ngIf="isLoading" class="loading-state">
    <mat-spinner diameter="30"></mat-spinner>
    <span>{{ 'common.loading' | translate }}</span>
  </div>

  <div *ngIf="hasError" class="error-state">
    <span>{{ 'currencyDialog.error' | translate }}</span>
  </div>

  <!-- Llista de les 6 monedes -->
  <div class="currency-list" *ngIf="!isLoading">
    <div *ngFor="let cur of visibleCurrencies" class="currency-row">
      
      <div class="currency-info" (click)="selectCurrency(cur.code)">
        <img [src]="flagUrl(cur.flag)" [alt]="cur.code" class="flag-img">
        <div class="currency-text">
          <span class="currency-code">{{ cur.code }}</span>
          <span class="currency-name">{{ cur.name }}</span>
        </div>
      </div>

      <div class="currency-value">
        <span class="rate-number">{{ getDisplayRate(cur) }}</span>
        <span class="currency-symbol">{{ cur.symbol }}</span>
      </div>

    </div>
  </div>

  <!-- Peu amb l'última actualització i botó d'actualitzar -->
  <div class="dialog-footer">
    <div class="update-info">
      <mat-icon>schedule</mat-icon>
      <span>{{ 'currencyDialog.updatedAt' | translate }} {{ updatedAt }}</span>
    </div>
    <button mat-stroked-button color="primary" (click)="loadRates()">
      <mat-icon>refresh</mat-icon>
      <span>{{ 'currencyDialog.refresh' | translate }}</span>
    </button>
  </div>

</div>